import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import './CURSOR.css';

let offsetX = 24;
let offsetY = 24;

// Displays the system cursor.
class CURSOR extends PureComponent {
    constructor(props) {
        super(props);
        window.WINAPI.cursor = this;
    }

    componentWillMount() {
        this.mouseMoveHandler = window.addEventListener('mousemove', (e) => {
            if (this.cursorElm) {
                this.cursorElm.style.transform = "translateX(" + (e.clientX - offsetX) + "px) " +
                    "translateY(" + (e.clientY - offsetY) + "px)";
            }
        });
        this.mouseLeaveHandler = document.body.addEventListener('mouseleave', (e) => {
            if (this.cursorElm) {
                this.cursorElm.style.display = 'none';
            }
        })
        this.mouseEnterHandler = document.body.addEventListener('mouseenter', (e) => {
            if (this.cursorElm) {
                this.cursorElm.style.display = 'block';
            }
        })
    }

    componentWillUnmount() {
        window.removeEventListener('mousemove', this.mouseMoveHandler);
        document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        document.body.removeEventListener('mouseenter', this.mouseEnterHandler);
        this.mouseMoveHandler = this.mouseLeaveHandler = this.mouseEnterHandler = null;
    }

    render() {
        var cursorStyle = {
            backgroundImage: "url(" + this.props.icon + ")"
        };
        if (this.cursorElm) { // wow violating react conventions
            cursorStyle.transform = this.cursorElm.style.transform;
            cursorStyle.display = this.cursorElm.style.display;
        }

        return <div className="cursor-container">
            <div className="cursor" ref={(e) => this.cursorElm = e} style={cursorStyle}></div>
        </div>;
    }

    setCursorVisible(visible) {
        if (!this.cursorElm) {
            return;
        }
        if (visible) {
            this.cursorElm.style.display = 'block';
        } else {
            this.cursorElm.style.display = 'none';
        }
    }
}

export default CURSOR;



// WEBPACK FOOTER //
// ./src/walleris/CURSOR.js